import(/* webpackMode: "eager", webpackExports: ["HousePromoDevProvider"] */ "/vercel/path0/frontend/components/ad/house-promo-dev-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegionPromptDeferred","MarketSwitchToastDeferred","CookieConsentDeferred","CreditLimitWarningBannerDeferred"] */ "/vercel/path0/frontend/components/deferred-layout-widgets.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocationHandoff"] */ "/vercel/path0/frontend/components/region/location-handoff.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwRegister"] */ "/vercel/path0/frontend/components/runtime/sw-register.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UiContentProvider"] */ "/vercel/path0/frontend/components/ui-content-provider.tsx");
